module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/social_media_icon-d50f04c31de36afeb5b051e920699ba8.png";